import React from "react";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { classNames } from "repoV2/utils/common/render/classNames";
import { IClassDetails } from "repoV2/features/CheckoutPages/utils/apis/SessionDetailsApi/SessionDetailsApi.interface";
import checkoutCommonStyles from "repoV2/features/CheckoutPages/CheckoutCommonStyles.module.scss";
import ExlySearchableDropdownV2 from "repoV2/features/Common/modules/Form/modules/ExlySearchableDropdownV2/ExlySearchableDrowpdownV2";
import useMultipleSessions from "./MultipleSessions.utils";
import styles from "./MultipleSessions.module.scss";

const MultipleSessions = (props: {
    classes: IClassDetails[];
    maxSpots: number;
}) => {
    const { classes, maxSpots } = props;

    const { multipleSessionsFieldName, classesOptions, batchesSelectorChange } =
        useMultipleSessions({ classes, maxSpots });

    return (
        <div className={checkoutCommonStyles.dropdownBorderStyles}>
            <ExlySearchableDropdownV2
                name={multipleSessionsFieldName}
                options={classesOptions}
                placeholder="Select a batch"
                renderOption={option => {
                    return (
                        <span
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={{
                                __html: option.data?.renderLabelValue || "",
                            }}
                        />
                    );
                }}
                onValueChange={batchesSelectorChange}
                classes={{
                    textInput: checkoutCommonStyles.inputBaseText,
                    helperText: checkoutCommonStyles.dropdownHelperText,
                    placeholder: checkoutCommonStyles.placeholderText,
                    inputRoot: classNames(
                        checkoutCommonStyles.selectInput,
                        styles.inputLabelStyles
                    ),
                    listbox: checkoutCommonStyles.selectMenuStyle,
                }}
                ExpandIcon={<ExpandMore />}
            />
        </div>
    );
};

export default MultipleSessions;
